import { Phone, ChevronDown, Star, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo, images } from '../data/mock';

export const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={`${images.hero}?auto=format&fit=crop&w=1920&q=80`}
          alt="Event lighting"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/85 to-zinc-950/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-zinc-950/30" />
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/4 right-1/4 w-72 h-72 bg-[#50ced4]/8 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-1/3 right-1/3 w-48 h-48 bg-[#c6dfff]/5 rounded-full blur-3xl" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-32 pb-20 w-full">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-sm text-zinc-300 mb-8">
            <MapPin className="w-4 h-4 text-[#50ced4]" />
            <span>Serving All Suburbs in Melbourne Area</span>
          </div>

          {/* Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-6">
            Premium{' '}
            <span className="text-[#50ced4]">Sound</span>
            <br />
            & Lighting Hire
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl text-zinc-400 leading-relaxed mb-10 max-w-xl">
            {businessInfo.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-14">
            <a href={`tel:${businessInfo.contact.phones[0].replace(/\s/g, '')}`}>
              <Button
                size="lg"
                className="bg-[#50ced4] hover:bg-[#3eb8be] text-zinc-950 font-bold px-8 py-6 text-base rounded-xl w-full sm:w-auto"
              >
                <Phone className="w-5 h-5 mr-2" />
                Call to Book
              </Button>
            </a>
            <a href="#packages">
              <Button
                size="lg"
                variant="outline"
                className="border-white/20 text-white hover:bg-white/10 hover:border-white/30 px-8 py-6 text-base rounded-xl w-full sm:w-auto bg-transparent"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#packages')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                View Packages
              </Button>
            </a>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap items-center gap-6 text-sm">
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" />
                ))}
              </div>
              <span className="text-zinc-400">Trusted by Local Community</span>
            </div>
            <div className="h-4 w-px bg-zinc-700 hidden sm:block" />
            <span className="text-zinc-400">Packages from <span className="text-[#50ced4] font-semibold">$100</span></span>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-xs text-zinc-500 uppercase tracking-widest">Scroll</span>
        <ChevronDown className="w-5 h-5 text-zinc-500" />
      </div>
    </section>
  );
};
